<template>
  <div style="height: 100%;width: 100%">
    <div style="height: 40px;margin: 10px 40px">
      <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
        <span>{{item.name}}</span>
      </div>
    </div>
    <div>
      <el-date-picker v-fixZoom
        size="small"
        v-model="sendDate"
        type="datetimerange"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd HH:mm:ss"
        style="width: 400px;margin-left: 40px"
        :clearable="false">
      </el-date-picker>
      <el-button size="small" type="primary" @click="onSubmit">查询</el-button>
    </div>
    <div style="height: 10px"></div>
    <div style="height: calc(100% - 103px)">
      <div v-if="indexActive === 0" style="margin: 0 40px;height: 100%;">
        <div style="height: 100%;">
          <el-table v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="infoLogData" border style="width: 100%" height="100%" highlight-current-row>
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column label="IMEI" prop="imei" min-width="80" align="center"></el-table-column>
            <el-table-column label="数据类型" prop="datatype" min-width="80" align="center"></el-table-column>
            <el-table-column label="GPS" prop="gps" min-width="70" align="center"></el-table-column>
            <el-table-column label="GSM" prop="gsm" min-width="70" align="center"></el-table-column>
            <el-table-column label="WIFI" prop="wifi" min-width="70" align="center"></el-table-column>
            <el-table-column label="Bluetooth" prop="bluetooth" min-width="90" align="center"></el-table-column>
            <el-table-column label="时间" prop="create_tm" min-width="80" align="center"></el-table-column>
            <el-table-column label="详细数据" prop="info" min-width="200" align="center"></el-table-column>
          </el-table>
        </div>
      </div>
      <div v-if="indexActive === 1" style="margin: 0 40px;height: 100%">
        <div style="height: 100%">
          <el-table v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="setLogData" border style="width: 100%" height="100%" highlight-current-row>
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column label="设置方法" min-width="80" align="center">
              <template slot-scope="scope">
                <span>{{getMethod(scope.row)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="设置时间" prop="create_tm" min-width="80" align="center"></el-table-column>
            <el-table-column label="设置详细值" prop="value" min-width="200" align="center"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import {querydevicesetlog, querydeviceinfolog} from '../../../api/device'
export default {
  name: 'deviceLog',
  model: {
    prop: 'deviceLogShow',
    event: 'change'
  },
  props: {
    deviceLogObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      row: '',
      indexActive: 0,
      tabs: [
        {index: 0, name: '设备数据日志'},
        {index: 1, name: '设备设置日志'}
      ],
      sendDate: [],
      loading: false,
      setLogData: [],
      infoLogData: []
    }
  },
  created () {
    this.row = this.deviceLogObj.deviceRow
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    const date = new Date().format('yyyy-MM-dd hh:mm:ss')
    this.sendDate = [date, date]
  },
  methods: {
    selectTab (item) {
      this.indexActive = item.index
    },
    onSubmit () {
      this.loading = true
      let data = {
        did: this.row.id,
        imei: this.row.deviceid,
        from: this.sendDate[0],
        to: this.sendDate[1]
      }
      if (this.indexActive === 0) {
        querydeviceinfolog(data).then(res => {
          let deviceInfo = res.data.deviceinfo
          this.infoLogData = deviceInfo
        })
      } else if (this.indexActive === 1) {
        querydevicesetlog(data).then(res => {
          let deviceSet = res.data.deviceset
          this.setLogData = deviceSet
        })
      }
      this.loading = false
    },
    getMethod (row) {
      let method = row.method
      if (method === 'community') {
        method = 'SOS呼叫号码'
      } else if (method === 'falldown') {
        method = '跌倒功能'
      } else if (method === 'falldown') {
        method = '跌倒功能'
      } else if (method === 'bluetoothswitch') {
        method = '蓝牙功能开关'
      } else if (method === 'requirelocation') {
        method = '按次定位'
      } else if (method === 'requirelocationperiod') {
        method = '按时间段定位'
      } else if (method === 'recordvoice') {
        method = '录音上传'
      } else if (method === 'getdevicesetting') {
        method = '获取设备设置信息'
      } else if (method === 'setclock') {
        method = '设置闹钟'
      } else if (method === 'setclock') {
        method = '设置闹钟'
      }
      return method
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemlog/childComponents/deviceLog.vue